import { RegisterResponse } from 'compliance-api/generated';
import dayjs from 'dayjs';
import { useCallback, useContext } from 'react';
import { CreatedByAiLabel } from '@/modules/common/components/CreatedByAiLabel.tsx';
import RegisterProgressBar from '@/modules/admin-dashboard/components/RegisterProgressBar.tsx';
import { DeleteModal } from '@/modules/admin-dashboard/components/modals/DeleteModal.tsx';
import { RenameModal } from '@/modules/admin-dashboard/components/modals/RenameModal.tsx';
import {
  useDeleteRegisterMutation,
  useUpdateRegisterMutation,
} from '@/modules/admin-dashboard/queries/registers.ts';
import { DisclosureListItem, ModalProviderContext } from 'ui';
import { EditIcon, TrashGrayIcon } from 'ui/icons';

interface RegisterItemProps {
  register: RegisterResponse;
}

const RegisterItem = ({ register }: RegisterItemProps) => {
  const { openModal } = useContext(ModalProviderContext);

  const handleOpenRenameModal = useCallback(() => {
    openModal(RenameModal, {
      name: register.name,
      id: register.id,
      title: 'label',
      mutation: useUpdateRegisterMutation,
    });
  }, [openModal, register.id, register.name]);

  const handleOpenDeleteModal = useCallback(() => {
    openModal(DeleteModal, {
      name: register.name,
      id: register.id,
      title: 'label',
      mutation: useDeleteRegisterMutation,
    });
  }, [openModal, register.id, register.name]);

  return (
    <DisclosureListItem
      leftMainString={register.name}
      leftSubduedContentSet={
        register.created_with_ai
          ? [
              `Created: ${dayjs(register.created_at).format('DD-MM-YYYY, HH:mm')}`,
              <CreatedByAiLabel created_with_ai={register.created_with_ai} />,
            ]
          : [`Created: ${dayjs(register.created_at).format('DD-MM-YYYY, HH:mm')}`]
      }
      classes={{ leftContent: 'w-1/2' }}
      rightContent={
        <div className="flex gap-2">
          <div className="flex items-center w-40 md:mr-5">
            <RegisterProgressBar register={register} />
          </div>
          <img
            src={EditIcon}
            alt="rename"
            className="cursor-pointer"
            onClick={handleOpenRenameModal}
          />
          <img
            src={TrashGrayIcon}
            alt="delete"
            className="cursor-pointer"
            onClick={handleOpenDeleteModal}
          />
        </div>
      }
    />
  );
};

export default RegisterItem;
